function Wave3Mobile(props) {
   return(
      <svg xmlns="http://www.w3.org/2000/svg" width="374.001" height="105.453" style={{transform: 'rotate(180deg)'}} viewBox="0 0 374.001 105.453">
         <path id="Wave_3" d="M11847.218,12798.953h0c-27.936-23.387-54.751-41.635-81.979-55.786a362.619,362.619,0,0,0-83.538-31.027c-14.291-3.438-29.084-6.205-45.223-8.456-15.171-2.116-31.218-3.731-49.056-4.938-37.5-2.539-78.776-2.886-114.2-2.89v-2.354h374v105.451h0v0Z" transform="translate(-11473.218 -12693.5)" fill="#fff"/>
      </svg>
   )
}

export default Wave3Mobile;